import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Wrapper from './Wrapper';
import {ContextProvider} from './SocketContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <ContextProvider>
      <Wrapper/>
    </ContextProvider>
);